import {request} from "@umijs/max"

export async function login(data: USER.LoginParams) {
  return request('/miot/api/rest/v2/auth/login', {
    method: 'POST',
    data,
    getResponse: true
  })
}

// 获取指定id的用户
export async function getUserById(userId: string) {
  return request(`/miot/api/rest/v2/sysUser/${userId}`)
}

// 获取用户列表
export async function getUserList(params: USER.UserListParams) {
  return request('/miot/api/rest/v2/sysUser/sysUsers', {
    params
  })
}

// 新增用户
export async function createUser(data: USER.Form) {
  return request('/miot/api/rest/v2/sysUser/sysUsers', {
    method: 'POST',
    data
  })
}

// 修改用户
export async function updateUser(data: USER.Form, userId: string) {
  return request(`/miot/api/rest/v2/sysUser/${userId}`, {
    method: 'PUT',
    data
  })
}

// 删除用户
export async function deleteUser(userId: string) {
  return request(`/miot/api/rest/v2/sysUser/${userId}`, {
    method: 'DELETE'
  })
}

// 查询权限列表
export async function getRoles() {
  return request<GLOBAL.response<USER.RoleInfo[]>>('/miot/api/rest/v2/sysRole/sysRoles/all')
}

export async function getSysUsersByList(params?: USER.UserListParams) {
  return request('/miot/api/rest/v2/sysUser/sysUsers/byList', {
     params
  });
}
